import { styled } from 'linaria/react';
import { breakpoints } from 'common/styles/breakpoints';

export const Container = styled.div`
  ${breakpoints.only.mobile} {
    display: inline;
  }

  ${breakpoints.from.tablet} {
    position: absolute;
    top: var(--space-300);
    right: var(--space-300);
    height: 112px;
    background-color: #ffffff;
    border: var(--space-50) solid var(--control-invert);
    border-radius: var(--space-50);
    box-shadow: var(--box-shadow-m);
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
`;

export const ImagePreview = styled.img`
  height: 100%;
  border-radius: var(--space-50);
  object-fit: contain;
  cursor: pointer;

  ${breakpoints.only.mobile} {
    height: auto;
    border-radius: var(--rounding-l);
    box-shadow: inset 0px 0px 1px rgba(0, 0, 0, 0.6);
    filter: none;
  }
`;

export const ModalContent = styled.div`
  padding: var(--space-800);

  ${breakpoints.only.mobile} {
    position: absolute;
    top: 50%;
    padding: var(--space-200);
    transform: translateY(-50%);
  }
`;
